import { useState } from "react";
import { Modal, Button, Form, Input } from "antd";
import { withRouter } from "react-router";
import { createMobileCopilotChatCategory } from "@api/copilots/mobile-app/mobileCopilotChatCategory";
import { SuccessNotification, ErrorNotification } from "../../..";

const initialState = {
  name: "",
  copilots: [],
};

const MobileCopilotChatCategoryCreateModal = ({
  open,
  handleModalClick,
  fetchCategories,
}) => {
  const [values, setValues] = useState(initialState);
  const [loading, setLoading] = useState(false);

  // Handle form change
  const handleFormChange = (e) => {
    e.preventDefault();
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  // Handle category create
  const handleMobileCopilotChatCategoryCreate = async (e) => {
    setLoading(true);
    e.preventDefault();

    // Validate form
    if (!values.name) {
      setLoading(false);
      return ErrorNotification("Please enter a name");
    }

    // Create a new category
    createMobileCopilotChatCategory(values)
      .then(() => {
        setValues(initialState);
        handleModalClick();
        fetchCategories();
        SuccessNotification(
          "Mobile Copilot Chat Category created successfully"
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.message);
      });
  };

  return (
    <>
      <Modal
        title="Create Category"
        visible={open}
        onOk={handleModalClick}
        closable={false}
        footer={[
          <Button key="back" onClick={handleModalClick}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleMobileCopilotChatCategoryCreate}
            loading={loading}
          >
            Create
          </Button>,
        ]}
      >
        <Form
          labelCol={{
            span: 5,
          }}
          wrapperCol={{
            span: 16,
          }}
        >
          {/* Category name */}
          <Form.Item label="Name">
            <Input
              name="name"
              placeholder="Enter category name"
              onChange={handleFormChange}
              value={values.name}
              rules={[{ required: true }]}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default withRouter(MobileCopilotChatCategoryCreateModal);
